// extracted by mini-css-extract-plugin
export var component = "TextModule-module--component--Nu+G7";
export var content = "TextModule-module--content--QJrKe";
export var title = "TextModule-module--title--IsRye";